module.exports = __webpack_public_path__ + "img/sr.437d8503.svg";